import { __awaiter } from "tslib";
import { BaseService } from "@/servicesTs/base";
export class FonasaValidationHistoryService extends BaseService() {
    static get entity() {
        return "fonasa_validations_histories";
    }
    static get responseName() {
        return "fonasa_validations_histories";
    }
    static getByPatientId(patient_id) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.submit({
                method: "get",
                path: `find_by_patient_id/${patient_id}`,
            });
        });
    }
}
